<template>
    <div class="device-add-page">
        <!-- 二维码卡片 -->
        <div class="qrcode-card">
            <div class="qrcode-wrapper">
                <!-- 这里可以替换为真实的二维码组件或图片 -->
                <img class="img" :src="require('../assets/images/bindNoScanIcon.png')" />
            </div>
            <!-- <div class="qrcode-tip">设备/充值号：xxxxxxxxxxxxxxxxxx</div> -->
        </div>

        <!-- 表单区域 -->
        <van-form class="device-form">
            <van-field v-model="form.deviceNo" label="*设备号:" placeholder="请输入设备号"
                :rules="[{ required: true, message: '请输入设备号' }]">
            </van-field>

            <van-field v-model="form.deviceNickname" label="设备昵称:" placeholder="昵称用于辨别不同的设备"
                :rules="[{ required: false, message: '请输入设备昵称' }]" />
        </van-form>

        <!-- 操作按钮 -->
        <div class="action-wrapper">
            <van-button type="primary" size="large" class="add-btn" @click="handleAddDevice">
                添加/查询设备
            </van-button>
            <div class="switch-login">
                <span>已绑定设备，</span>
                <span class="link" @click="handleSwitchLogin">切换账号登录</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DeviceAddPage',
    data() {
        return {
            form: {
                deviceNo: '',
                deviceNickname: ''
            }
        }
    },
    methods: {
        handleAddDevice() {
            this.$toast('添加设备')
            // 这里调用添加设备接口
        },
        handleSwitchLogin() {
            this.$toast('切换账号登录')
            // 这里处理切换账号逻辑
        }
    }
}
</script>

<style lang="scss" scoped>
.device-add-page {
    min-height: 100vh;
    background: #f8f9fa;
    padding: 20px;
    box-sizing: border-box;
}

.qrcode-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    margin-bottom: 30px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    .qrcode-wrapper {
        margin-bottom: 12px;
    }

    .qrcode-tip {
        font-size: 12px;
        color: #999;
    }
}

.device-form {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 30px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    .manual-input {
        font-size: 14px;
        color: #1989fa;
    }
}

.action-wrapper {
    text-align: center;

    .add-btn {
        width: 60%;
        border-radius: 24px;
        background: #82aaff;
        border: none;
        margin-bottom: 20px;
    }

    .switch-login {
        font-size: 14px;
        color: #666;

        .link {
            color: #1989fa;
        }
    }
}
</style>